import React from 'react';
import V1EnterLayout from './V1EnterLayout';

interface V1CheckoutAndIdentityProps {}

const Login = () => (
  <div>
    V1
    <br />
    LOGIN
  </div>
);
const Checkout = () => (
  <div>
    V1
    <br />
    CHECKOUT
  </div>
);
const SummaryArea = () => (
  <div>
    V1
    <br />
    SUMMARY AREA
  </div>
);

export const V1CheckoutAndIdentity: React.FC<
  V1CheckoutAndIdentityProps
> = ({}) => {
  return (
    <V1EnterLayout
      desktopLeft={
        <>
          <Login />
          <Checkout />
        </>
      }
      desktopRight={
        <>
          <SummaryArea />
        </>
      }
      mobileView={
        <>
          <SummaryArea />
          <Login />
          <Checkout />
        </>
      }
    />
  );
};

export default V1CheckoutAndIdentity;
